import React from "react";
import { Props } from "./types";
import { OpenFolderIcon } from "./openFolderIcon";
import { ClosedFolderIcon } from "./closedFolderIcon";

function FolderIcon(props: Props) {
  return props.isOpen ? (
    <OpenFolderIcon
      className={props.className || ""}
      style={props.style || {}}
    />
  ) : (
    <ClosedFolderIcon
      className={props.className || ""}
      style={props.style || {}}
    />
  );
}

export { FolderIcon };
